<div class="frame-in">
    <div id="game-container" [hidden]="loading" class="phaser-3"></div>
</div>
